import { ROUTES } from '@shared/config/routes'
import { readSessionFlag, writeSessionFlag } from '@shared/lib'

const STORAGE_PREFIX = 'profile-city-notice-seen-'

/** Видел ли участник окно в этой вкладке. Нет хранилища — не видел. */
export function isProfileCityNoticeSeen(participantId: number): boolean {
  return readSessionFlag(STORAGE_PREFIX + participantId)
}

export function markProfileCityNoticeSeen(participantId: number): void {
  writeSessionFlag(STORAGE_PREFIX + participantId)
}

interface NoticeInput {
  /** Город профиля — «Другое» (профиль и справочник уже загружены). */
  isOtherCity: boolean
  pathname: string
  /** Закрыто в этой вкладке (флаг хранилища или состояние компонента). */
  seen: boolean
  /** Поверх открыто другое окно кабинета. */
  suspended: boolean
}

/** Показывать ли окно «Проверьте данные профиля». На самой странице профиля его нет:
 *  человек уже там, где город меняют. */
export function shouldShowProfileCityNotice({
  isOtherCity,
  pathname,
  seen,
  suspended,
}: NoticeInput): boolean {
  return isOtherCity && !seen && !suspended && pathname !== ROUTES.PARTICIPANT_PERSONAL
}
